import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactCountryFlag from "react-country-flag";

function Hero() {
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);

  const fetchData = async () => {
    try {
      const res = await axios.get("https://goawin.xyz/api/domain/blogs", {
        withCredentials: true,
      });

      const blogsData = res.data.data || res.data.blogs || [];

      setBlogs(blogsData);

      const uniqueCategories = [
        ...new Set(
          blogsData.map((blog) => blog.category?.name).filter(Boolean),
        ),
      ];

      setCategories(uniqueCategories);
    } catch (err) {
      console.log("Server Error");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <section className="relative flex items-center justify-center overflow-hidden bg-[#f8f8f8] pt-32 dark:bg-[#050505]">
      <div className="absolute left-0 top-0 h-[500px] w-[500px] rounded-full bg-primary/10 blur-[140px]" />
      <div className="absolute bottom-0 right-0 h-[500px] w-[500px] rounded-full bg-orange-300/10 blur-[140px]" />

      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] bg-[size:70px_70px] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)]" />

      <div className="relative z-10 w-full max-w-7xl px-4">
        <div className="grid items-center gap-10 lg:grid-cols-[60%_40%]">
          <div>
            <p className="mb-3 font-medium tracking-wide text-orange-500">
              Latest Articles & Insights
            </p>

            <h1 className="text-4xl font-bold leading-tight text-gray-900 dark:text-white md:text-6xl">
              Also Read Our Blogs & Stay Updated
            </h1>

            <p className="mt-5 max-w-3xl text-sm text-gray-600 dark:text-gray-300 md:text-base">
              Discover web development, SEO, digital marketing, business growth
              strategies and industry insights written by our experts.
            </p>
          </div>

          <div className="grid">
            <div className="mt-4 max-w-md">
              <h3 className="mb-4 text-2xl font-bold text-gray-900 dark:text-white">
                Explore Topics
              </h3>

              <div className="overflow-hidden rounded bg-white/80 shadow-sm backdrop-blur-xl dark:bg-white/5">
                {categories.map((category, index) => {
                  const count = blogs.filter(
                    (blog) => blog.category?.name === category,
                  ).length;

                  return (
                    <button
                      key={category}
                      className="flex w-full items-center justify-between border-b border-gray-100 px-4 py-3 text-left transition hover:bg-orange-50 dark:border-white/10 dark:hover:bg-white/5"
                    >
                      <div className="flex items-center gap-2">
                        <span className="text-gray-400">›</span>

                        <span className="font-medium text-gray-900 dark:text-white">
                          {category}
                        </span>
                      </div>

                      <span className="rounded-full bg-orange-100 px-2 py-1 text-xs font-medium text-orange-600 dark:bg-orange-500/10">
                        {count}
                      </span>
                    </button>
                  );
                })}

                {categories.length === 0 && (
                  <div className="px-4 py-4 text-sm text-gray-500 dark:text-gray-300">
                    No categories found.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 rounded-xl bg-white/80 p-6 shadow-sm backdrop-blur-xl dark:bg-white/5">
          {/* Author */}
          <div className="border-b border-gray-200 pb-5 dark:border-white/10">
            <p className="text-sm font-medium uppercase tracking-wider text-orange-500">
              Written By
            </p>

            <h3 className="mt-2 text-2xl font-bold text-gray-900 dark:text-white">
              Rohit Bhardwaj
            </h3>

            <p className="mt-2 text-gray-600 dark:text-gray-400">
              Founder of Web X Secure, Full Stack Developer, Digital Marketing
              Strategist and Cyber Security Analyst. Sharing practical guides,
              industry insights, business growth strategies and real-world
              experiences to help professionals and businesses succeed online.
            </p>
          </div>

          {/* Countries */}
          <div className="mt-6">
            <h4 className="mb-4 font-semibold text-gray-900 dark:text-white">
              Our Content is Read Across 9+ Countries
            </h4>

            <div className="hidden md:grid grid-cols-3 gap-3 lg:grid-cols-9">
              {[
                { code: "IN", name: "India" },
                { code: "US", name: "USA" },
                { code: "GB", name: "UK" },
                { code: "AE", name: "UAE" },
                { code: "AU", name: "Australia" },
                { code: "CA", name: "Canada" },
                { code: "DE", name: "Germany" },
                { code: "FR", name: "France" },
                { code: "JP", name: "Japan" },
              ].map((country) => (
                <div
                  key={country.code}
                  className="flex items-center gap-3 rounded-xl border border-gray-200 p-3 dark:border-white/10"
                >
                  <ReactCountryFlag
                    countryCode={country.code}
                    svg
                    style={{
                      width: "28px",
                      height: "28px",
                    }}
                  />

                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    {country.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
